
import React from 'react';
import { motion } from 'framer-motion';

export const HeaderBackground: React.FC = () => {
  return (
    <>
      <div className="absolute inset-0 opacity-10">
        <div className="absolute top-0 left-0 w-full h-full bg-grid-white/[0.2]"></div>
      </div>
      
      <motion.div 
        className="absolute -top-20 -right-20 w-64 h-64 rounded-full bg-fuchsia-400/30 blur-3xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 1 }}
        transition={{ duration: 1.5 }}
      />
      
      <motion.div 
        className="absolute top-40 -left-20 w-48 h-48 rounded-full bg-teal-300/30 blur-3xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.8 }}
        transition={{ duration: 2, delay: 0.3 }}
      />
      
      <motion.div 
        className="absolute -bottom-32 left-1/3 w-80 h-80 rounded-full bg-amber-200/20 blur-3xl"
        initial={{ opacity: 0 }}
        animate={{ opacity: 0.7 }}
        transition={{ duration: 1.8, delay: 0.7 }}
      />
    </>
  );
};
